<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :multiple="multiple"
            :showAdd="showAdd"
            :dense="dense"
            :selectAll="selectAll"
            :auto-complete="autoComplete"
            :disabled="disabled"
            @onSelectAll="$emit('onSelectAll', $event)"
        />
        <sys-register-ambience-type @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectAmbienceType',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        onlyInPerson: {
            type: Boolean,
            default: false
        },
        onlyWithLink: {
            type: Boolean,
            default: false
        },
        campusId: {
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },

        campusId(){
            this.getItems();
        },
        
        model(val){
            this.selected = val;
        },
    },
    methods: {
        ...mapActions('ambienceType', ['ActionFindAmbienceTypes']),        
        
        async getItems() {

            this.loading = true;

            var payload = {
                column_order: 'name',
                find_columns: {
                    active: 1
                }
            };

            if(this.onlyInPerson){
                payload.find_columns.is_virtual = 0
            }

            if(this.onlyWithLink){
                payload.find_columns.allow_ambience_link = 1;
            }

            if(this.campusId && this.campusId.length !== 0){
                payload.filter_relations = [
                    {
                        name:   'ambiences',
                        key:    'campus_id', 
                        value:  this.campusId,
                    }    
                ];
            }

            if(this.multiple){
                this.selected = [];
            }else{
                this.selected = null;
            }

            await this.ActionFindAmbienceTypes(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>